export enum CountryPhoneCode {
  GERMANY = '+49',
  AUSTRIA = '+43',
}
